<template>
    <div class="bindPage rightPage">
        <div class="layout">
            <v-search
                :formContent="formContent"
                :SearchForm="SearchForm"
                :inline="true"
                :optareBtn="optareBtn"
                :treePathObj="treePathObj"
                @resetFn="resetFn"
                @confirmFn="getListFn"
                @searchFn="getListFn"
                @delFn="delFn"
                @editScopeFn="editScopeFn"
                @useAgainFn="useAgainFn"
            />
            <div class="componentPage">
                <stopTable
                    :tableData="tableData"
                    v-bind="$attrs"
                    :loading="loading"
                    @choozeTable="choozeTable"
                    @delRowFn="delRowFn"
                    @editScopeRowFn="editScopeRowFn"
                    @useAgainRowFn="useAgainRowFn"
                    @detailFn="detailFn"
                    @historyFn="historyFn"
                    @dataHandleFn="dataHandleFn"
                />
                <Pagination class="pagination" :total="total" :page.sync="SearchForm.iDisplayStart" :limit.sync="SearchForm.iDisplayLength" @pagination="getListFn"></Pagination>
            </div>
        </div>

        <!-- 修改范围 -->
        <EditScope :isShowEditShow.sync="isShowEditShow" :scopeArray="scopeArray" ref="scopedId" />
        <!-- 详情 -->
        <!-- <DetailDialog :isDetailShow.sync="isDetailShow" :title="title" :detailObj="detailObj" :deviceType="deviceType"
      :deviceProperty="deviceProperty" :netObj="netObj" v-bind="$attrs" ref="detailDialog" @changdetail="changdetail" /> -->
    </div>
</template>

<script>
import formMixin from '@/utils/formMixins.js';
import getAllTreePath from '@/utils/getAllTreePath.js';
import bus from '@/utils/bus.js';
import { getDeviceTypeToSelection } from '@/utils/searchSelectFormat';
import stopTable from './stopTable.vue';
import EditScope from '../components/EditScope.vue';
import { baseList, updateBaseStatus, delBase } from '@/api/modules/base.js';
import { shareScope } from '@/api/modules/public.js';
import { sBaseNo, sCarrier, sBindedDevice, sBaseType, sBaseStatus, sBindCarrier } from '../config/search';
import { baseHistory } from '@/utils/winDetail';
export default {
    mixins: [formMixin, getAllTreePath],
    components: {
        stopTable,
        EditScope
    },
    computed: {
        /** 用于表示当前登录用户属于什么类型的角色 */
        sysAdmin() {
            const currentUser = this.$store.getters.userInfo.scope;
            if (currentUser.sysScope && currentUser.sysAdmin) {
                //系统管理员
                return 'isSysAdmin';
            } else if (currentUser.sysScope && !currentUser.sysAdmin) {
                //系统非管理员
                return 'isSysNoAdmin';
            } else if ((!currentUser.sysScope && currentUser.scopeAdmin) || currentUser.type === 2) {
                //非系统管理员 以及代理角色  代理角色是迭代7的需求添加
                return 'noSysIsAdmin';
            } else {
                //非系统非管理员
                return 'noSysNoAdmin';
            }
        }
    },
    data() {
        return {
            formContent: [sBaseNo, sCarrier, sBindedDevice, sBaseType, sBaseStatus, sBindCarrier],
            SearchForm: {
                scopeName: this.$store.state.SchemaTree[0].sceneCode === 'all_node' ? null : this.$store.state.SchemaTree[0].label,
                name: null,
                type: null,
                mac: null,
                carrierName: null
            },
            total: 0,
            optareBtn: [
                {
                    id: 1,
                    icon: '',
                    vHas: ['incubatorAddCarrier'],
                    text: 'public.tbopt_delete',
                    method: 'delFn'
                },
                // {
                //   id: 2,
                //   icon: '',
                //   vHas: ["incubatorAddCarrier"],
                //   text: 'public.net_param',
                //   method: 'netFn'
                // },
                {
                    id: 4,
                    icon: '',
                    vHas: ['incubatorAddCarrier'],
                    text: 'device.reuse',
                    method: 'useAgainFn'
                }
            ],
            choozeTableData: [],

            title: '',
            // 修改范围
            isShowEditShow: false,
            scopeArray: [],
            // 详情
            isDetailShow: false,
            detailObj: {},
            // 属性的健名
            deviceType: {},
            // 属性的对应值
            deviceProperty: {},
            netObj: {},
            // 把表格的数据也传递过去
            rowData: {}
        };
    },
    mounted() {
        bus.$off('nodeClickFn');
        bus.$on('nodeClickFn', row => {
            // 获取完整的路径
            this.getAllPath(row);
            this.treeClickSearchFn(row);
        });
        if (this.sysAdmin === 'noSysNoAdmin') {
            this.optareBtn.pop();
        }
        if (this.sysAdmin === 'isSysAdmin' || this.sysAdmin === 'isSysNoAdmin') {
            this.optareBtn.push({
                id: 3,
                icon: '',
                vHas: ['incubatorAddCarrier'],
                text: 'device.modify_customer',
                method: 'editScopeFn'
            });
        }

        // 获取类型
        const item = this.formContent.find(item => item.paramsName === 'type');
        getDeviceTypeToSelection('base', item);
    },
    methods: {
        /** 分页 */
        getListFn() {
            this.loading = true;
            baseList(this.SearchForm, 'stop')
                .then(res => {
                    const { result, pageInfo } = res.result;
                    this.tableData = result;
                    this.total = pageInfo.total;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        /** 点击树形查询 */
        treeClickSearchFn(row) {
            if (row.id === 'all') {
                this.SearchForm.sceneId = null;
                this.SearchForm.scopeName = null;
            }
            // 一级范围
            else if (row.level === 0 && row.id !== 'all') {
                this.SearchForm.sceneId = null;
                this.SearchForm.scopeName = row.label;
            } else {
                this.SearchForm.scopeName = null;
                this.SearchForm.sceneId = row.sceneId;
            }
            this.getListFn();
        },
        resetFn() {
            this.SearchForm = {
                scopeName: this.$store.state.SchemaTree[0].sceneCode === 'all_node' ? null : this.$store.state.SchemaTree[0].label,
                name: null,
                type: null,
                mac: null,
                carrierName: null,
                iDisplayStart: 0,
                iDisplayLength: 15
            };
            bus.$emit('initTree');
            this.treePathObj = this.$store.state.SchemaTree[0].sceneCode === 'all_node' ? null : this.$store.state.SchemaTree[0].label;
            this.getListFn();
        },
        choozeTable(row) {
            this.choozeTableData = row;
        },

        /** 多条删除 */
        delFn() {
            if (this.choozeTableData.length === 0) return this.$message.warning(this.$t('public.least_one_data'));
            this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
                confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
                cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
                type: 'warning'
            })
                .then(() => {
                    let idList = this.choozeTableData.map(item => item.id);
                    const query = { ids: idList.join(','), edited: 1 };
                    delBase(query).then(async ({ state }) => {
                        await this.$resultHandle(state);
                        this.getListFn();
                    });
                })
                .catch(() => {});
        },
        /** 单条删除 */
        delRowFn(row) {
            this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
                confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
                cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
                type: 'warning'
            })
                .then(() => {
                    const query = { ids: row.id, edited: 1 };

                    delBase(query).then(async ({ state }) => {
                        await this.$resultHandle(state);

                        this.getListFn();
                    });
                })
                .catch(() => {});
        },
        /** 修改范围 */
        editScopeFn() {
            if (this.choozeTableData.length === 0) return this.$message.warning(this.$t('public.least_one_data'));
            let flag = this.distinguishTypeFn('scene_id');
            if (!flag) return this.$message.error($t('integration.the_selected_gateway_is_not_the_same_customer'));
            this.isShowEditShow = true;
            this.getSence();
            this.$nextTick(() => {
                this.$refs['scopedId'].dioForm.sceneId = this.choozeTableData[0].sceneId;
                this.$refs['scopedId'].dioForm.id = this.choozeTableData[0].id;
            });
        },
        /** 单条修改范围 */
        editScopeRowFn(row) {
            this.isShowEditShow = true;
            this.getSence();
            this.$nextTick(() => {
                this.$refs['scopedId'].dioForm.sceneId = row.sceneId + '';
                this.$refs['scopedId'].dioForm.id = row.id;
            });
        },
        /** 区分勾选中的数据是否是同一种类型 */
        distinguishTypeFn(str) {
            if (this.choozeTableData.length === 1) return true;

            let oneParam = this.choozeTableData[0];
            let flag = true;
            for (let item of this.choozeTableData) {
                if (oneParam[str] !== item[str]) {
                    flag = false;
                    break;
                } else {
                    flag = true;
                }
            }
            return flag;
        },
        /** 获取范围 */
        getSence() {
            shareScope({tab:1}).then(res => {
                if (res.state.code == 200) {
                    this.scopeArray = res.result.filter(item => {
                        return item.id > 0;
                    });
                }
            });
        },
        /** 重新使用 */
        useAgainFn() {
            if (this.choozeTableData.length === 0) return this.$message.warning(this.$t('public.least_one_data'));
            let idList = this.choozeTableData.map(item => item.id);
            // let query = qs.stringify({ ids: idList.join(','), status: 0 });
            this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
                confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
                cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
                type: 'warning'
            })
                .then(() => {
                    updateBaseStatus(idList.join(','), 'use').then(async ({ state }) => {
                        await this.$resultHandle(state);
                        this.getListFn();
                    });
                })
                .catch(() => {});
        },
        /** 单条重新使用 */
        useAgainRowFn(row) {
            // let query = qs.stringify({ ids: row.id, status: 0 });
            this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
                confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
                cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
                type: 'warning'
            })
                .then(() => {
                    updateBaseStatus(row.id, 'use').then(async ({ state }) => {
                        await this.$resultHandle(state);
                        this.getListFn();
                    });
                })
                .catch(() => {});
        },

        changdetail(row) {
            this.detailFn(row);
        },
        /** 详情 */
        detailFn(row) {
            bus.$emit('baseParam', row.id, row.plinthCode, this.getListFn);
        },
        historyFn(row) {
            bus.$emit('bindHistoryParam', row.id);
        },
        dataHandleFn(row) {
            baseHistory(row.plinthCode);
        }
    }
};
</script>

<style lang="scss" scoped>
.bindPage {
    height: 100%;
    padding-right: 15px;
    box-sizing: border-box;

    .layout {
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;
    }

    .componentPage {
        flex: 1;

        .pagination {
            padding-top: 0;
            padding-right: 15px !important;
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }
}
</style>
